import { buildGlobalReferenceContext } from '../../context/buildGlobalReferenceContext.mjs';

const [TagContextProvider, useTagContext] = buildGlobalReferenceContext("Tag");

export { TagContextProvider, useTagContext };
//# sourceMappingURL=context.mjs.map
